var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { TForm } from "./TForm";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { TActions } from "./TActions";
import { Dialog } from "@mui/material";
import DialogContentText from "@mui/material/DialogContentText";
import { useAsyncAction } from "nate-react-api-helpers";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Context = /*#__PURE__*/ createContext({ show: function () { return console.error("invalid context"); } });
export function useTConfirm(props) { var ctx = useContext(Context); return useCallback(function () { ctx.show(props); }, [props, ctx]); }
export function TConfirmProvider(props) {
    var _this = this;
    var _a = useState(""), title = _a[0], setTitle = _a[1];
    var _b = useState(""), text = _b[0], setText = _b[1];
    var _c = useState(false), show = _c[0], setShow = _c[1];
    var _d = useState({ callback: function () { return new Promise(function (resolve, reject) { return reject("error"); }); } }), confirm = _d[0], setConfirm = _d[1];
    var action = useAsyncAction(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, confirm.callback()];
            case 1:
                _a.sent();
                setShow(false);
                return [2 /*return*/];
        }
    }); }); }, [confirm]);
    var ctx = useMemo(function () { return { show: function (props) { setTitle(props.title); setText(props.text); setConfirm({ callback: props.onConfirm }); setShow(true); } }; }, []);
    return /*#__PURE__*/ _jsx(_Fragment, { children: /*#__PURE__*/ _jsxs(Context.Provider, { value: ctx, children: [props.children, /*#__PURE__*/ _jsx(Dialog, { open: show, maxWidth: "xs", fullWidth: true, children: /*#__PURE__*/ _jsxs(TForm, { onSubmit: function () { return action.callback(null); }, children: [/*#__PURE__*/ _jsx(DialogTitle, { children: title }), /*#__PURE__*/ _jsxs(DialogContent, { children: [text.split("\n\n").map(function (s) { /*#__PURE__*/ return _jsx(DialogContentText, { style: { marginBottom: 8 }, children: s }); }), /*#__PURE__*/ _jsx(TActions, { loadingOrError: action.LoadingElement, onCancel: function () { return setShow(false); }, confirmText: "Confirm" })] })] }) })] }) });
}
